const styles = (theme) => ({
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
    },
});

export default styles;
